// V1.5+ Slice 5 — Jam Relay tuning per docs/02_GAME_DESIGN.md §13 / §16.
//
// Jam Relay is the Engineer's E (secondary) ability and the parity counterpart
// to Recon's Cut Link (Slice 2). Where Cut Link is a HAMMER — it severs the
// relay's chain so downstream relays cascade to isolated, vision drops, and
// forward `mini_turret`s anchored on those relays go dark — Jam Relay is a
// SCALPEL: while a relay is jammed, it grants no vision to its owner, but the
// signal chain stays INTACT (BFS still traverses through the jammed node, so
// downstream relays remain connected; income is unaffected; forward turrets
// stay online). The two abilities are mechanically distinct and create
// different strategic reads:
//
//   "Recon's Cut Link breaks the enemy's whole forward extension."
//   "Engineer's Jam Relay creates a blind spot exactly where I'm pushing."
//
// §16 "felt on the battlefield" check: jamming an enemy relay opens a
// vision corridor through the jammed node's tile, so the attacker can move
// squads through unseen for the jam window. The defender gets a banner
// ("RELAY JAMMED — Xs") and the audio cue (`relay_jammed`) on the rising
// edge so they know exactly what was lost (per §16's "must understand what
// was cut" rule); the chain itself doesn't break, so income/turrets/
// downstream-relay-connectivity remain intact.
//
// Calibration:
//   - The Engineer must be within `JAM_RELAY_TARGET_RANGE_PX` of the relay
//     (200 px — slightly tighter than Cut Link's 220 px because Engineer
//     is tankier and can commit closer; tightness is part of the parity
//     differentiation against Recon's longer reach).
//   - The channel takes `JAM_RELAY_CHANNEL_SEC` seconds (2 s — shorter than
//     Cut Link's 3 s; standing in front of an enemy relay is exposed and
//     Engineer's lower mobility means a longer channel would be a death
//     sentence, but the channel still has to give the defender a reaction
//     window per §13 counterplay).
//   - The jam lasts `JAM_RELAY_DURATION_SEC` seconds (20 s — shorter than
//     Cut Link's 30 s; the strategic intent is "punctual blind spot for a
//     push," not "shut down their whole forward zone").
//   - Cooldown `JAM_RELAY_COOLDOWN_SEC` is shorter than Cut Link's 45 s —
//     scalpel-class abilities are spammier than hammer-class abilities.
//
// Per Rule 17 (anti-turtling) and Rule 18 (felt on the battlefield), the
// values are tuned so the strategic dynamic §16 calls out emerges:
//   "I jammed his mid relay. He can't see me crossing the choke. By the
//    time the jam expires, my squads are already at his forward turret."
export const JAM_RELAY_TARGET_RANGE_PX = 200;
export const JAM_RELAY_TARGET_RANGE_SQ = JAM_RELAY_TARGET_RANGE_PX * JAM_RELAY_TARGET_RANGE_PX;
export const JAM_RELAY_CHANNEL_SEC = 2;
export const JAM_RELAY_DURATION_SEC = 20;
export const JAM_RELAY_COOLDOWN_SEC = 35;
